import { LocationDescriptorObject } from 'history';
import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';

import { StyledMenuNavLink } from 'src/app/graph/documentationPage/schemaPage/styledMenuNavLink/StyledMenuNavLink';

export function L3SettingsMenu<Tab extends string>({
  settingsMenuItems,
  applyRouteConfig,
  defaultSlug,
  currentTab,
}: {
  settingsMenuItems: ReadonlyArray<
    {
      slug: Tab;
      title: string;
    } & (
      | { nested?: undefined; defaultNested?: undefined }
      | {
          nested: ReadonlyArray<{ slug: Tab; title: string }>;
          defaultNested: Tab;
        }
    )
  >;
  applyRouteConfig: (tabName: Tab) => LocationDescriptorObject<unknown>;
  defaultSlug: Tab;
  currentTab?: Tab;
}) {
  return (
    <nav className="mt-4 flex flex-1 flex-col overflow-y-auto pb-6 pl-4">
      {settingsMenuItems.map(({ slug, title, nested, defaultNested }) => {
        const isActive =
          currentTab === slug ||
          (currentTab === undefined && slug === defaultSlug);
        return (
          <Fragment key={slug}>
            <StyledMenuNavLink
              to={applyRouteConfig(slug)}
              // special-case because this is the default route
              isActive={() =>
                isActive ||
                (nested ?? []).some(
                  ({ slug: nestedSlug }) => currentTab === nestedSlug,
                )
              }
              className="my-1"
            >
              {slug === 'linter' ? (
                <div className="flex items-center">{title}</div>
              ) : (
                title
              )}
            </StyledMenuNavLink>
            {nested?.map(({ slug: nestedSlug, title: nestedTitle }) => (
              <NavLink
                key={nestedSlug}
                to={applyRouteConfig(nestedSlug)}
                className="my-1 ml-4 flex break-all rounded border border-transparent px-3 py-1 text-base text-neutral transition duration-150 hover:bg-neutral"
                isActive={() =>
                  currentTab === nestedSlug ||
                  (currentTab === undefined && slug === defaultNested) ||
                  (nestedSlug === defaultNested && isActive)
                }
                activeClassName="font-semibold"
              >
                {nestedTitle}
              </NavLink>
            ))}
          </Fragment>
        );
      })}
    </nav>
  );
}
